import { formatWeekdayDateOrDash } from "@shared-core/domain/formatters";
import { Badge } from "../../primitives/badge";

interface VisibilityProvenanceBadgeProps {
  visibilityReason?: string | null;
  coveringForUserName?: string | null;
  coverUntil?: string | null;
  className?: string;
}

/**
 * Explains *why* a viewer can see a customer/job that isn't on their own
 * portfolio (views_module's `visibility_reason`/`covering_for_user_name`/
 * `cover_until` provenance — README.md §"Provenance"). Renders nothing for
 * "own" (the common case needs no explanation) or an absent/unrecognised
 * reason. Shared across customer-list, csr-home job rows, work-portfolio
 * items, and customer-360.
 */
export function VisibilityProvenanceBadge({
  visibilityReason,
  coveringForUserName,
  coverUntil,
  className,
}: VisibilityProvenanceBadgeProps) {
  if (visibilityReason === "covering") {
    return (
      <Badge variant="neutral" className={className}>
        Covering for {coveringForUserName ?? "someone"}
        {coverUntil ? ` until ${formatWeekdayDateOrDash(coverUntil)}` : ""}
      </Badge>
    );
  }
  if (visibilityReason === "catch_all") {
    return (
      <Badge variant="neutral" className={className}>
        Unallocated account
      </Badge>
    );
  }
  return null;
}
